import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { loadableWithRetry } from './services/loadableWithRetry';

// Critical pages (eagerly loaded)
import LandingPage from './pages/LandingPage';
import BuyCreditsPage from './pages/BuyCreditsPage';
import CallPage from './pages/CallPage';

// Shared components (eagerly loaded)
import Navbar from './components/NavBar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Lazy-loaded non-critical pages/components
const LoginPage = lazy(loadableWithRetry(() => import('./pages/LoginPage')));
const RegisterPage = lazy(loadableWithRetry(() => import('./pages/RegisterPage')));
const CallHistory = lazy(loadableWithRetry(() => import('./components/CallHistory')));
const VerifyEmailPage = lazy(loadableWithRetry(() => import('./pages/VerifyEmailPage')));
const EmailVerifiedPage = lazy(loadableWithRetry(() => import('./pages/EmailVerifiedPage')));
const BillingHistory = lazy(loadableWithRetry(() => import('./components/BillingHistory')));
const EmailCheckPage = lazy(loadableWithRetry(() => import('./pages/EmailCheckPage')));
const ProfilePage = lazy(loadableWithRetry(() => import('./pages/ProfilePage')));
const ForgotPassword = lazy(loadableWithRetry(() => import('./pages/ForgotPassword')));
const ResetPassword = lazy(loadableWithRetry(() => import('./pages/ResetPassword')));
const SupportPage = lazy(loadableWithRetry(() => import('./pages/SupportPage')));
const TermsOfService = lazy(loadableWithRetry(() => import('./pages/TermsOfService')));
const PrivacyPolicy = lazy(loadableWithRetry(() => import('./pages/PrivacyPolicy')));
const FAQPage = lazy(loadableWithRetry(() => import('./components/Faq')));
const AllowedCountriesPage = lazy(loadableWithRetry(() => import('./pages/AllowedCountriesPage')));
const BlogIndexPage = lazy(loadableWithRetry(() => import('./pages/blog/BlogIndexPage')));
const BlogPostPage = lazy(loadableWithRetry(() => import('./pages/blog/BlogPostPage')));
const NotFoundPage = lazy(loadableWithRetry(() => import('./pages/NotFoundPage')));


function App() {
  return (
    <>
      <Navbar />
      <div className="min-h-screen px-4 py-6 sm:px-6 md:px-10 lg:px-12 xl:px-16 2xl:px-20">
        <ScrollToTop />
        <Suspense fallback={<div className="text-center py-10">Loading...</div>}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/call" element={<CallPage />} />
            <Route path="/buy-credits" element={<BuyCreditsPage />} />

            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/call-history" element={<CallHistory />} />
            <Route path="/billing-history" element={<BillingHistory />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/email-verified" element={<EmailVerifiedPage />} />
            <Route path="/check-email" element={<EmailCheckPage />} />
            <Route path='/profile' element={<ProfilePage />} />
            <Route path='/forgot-password' element={<ForgotPassword />} />
            <Route path='/reset-password/:token' element={<ResetPassword />} />
            <Route path='/support' element={<SupportPage />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path='/faq' element={<FAQPage />} />
            <Route path='/destinations' element={<AllowedCountriesPage />} />

            <Route path="/blog" element={<BlogIndexPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </div>
      <Footer />
    </>
  );
}

export default App;
